import Slider from "./Slider";
import Introduction from "./Introduction";
import Instgram from "./Instgram";
import Skill from "./Skill";
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import styled from 'styled-components';

const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const Main: React.VFC = () => {
  return (
    <div className="App">
      <ScrollToTopOnMount />
      <Mt></Mt>
      {/* スライダー */}
      <Slider />
      {/* 体験会のご案内 */}
      <Introduction />
      <Instgram />
      <Skill />
    </div>
  );
}
export default Main;
